<template>
  <div class="capitalAccount">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>商户名称：</span>
          <div>
            <el-select v-model="companyValue" placeholder="请选择">
              <el-option
                v-for="item in CompanyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 50px;"></span>
          <el-button type="primary" @click="merchantsSearch" size="small">搜索</el-button>
          <el-button type="danger" @click="merchantsReset" size="small">重置</el-button>
        </div>
      </div>
      <div style="width: 100px;position:relative ">
        <div style="position:absolute; top:50%;transform:translateY(-50%)"></div>
      </div>
      <div class="bottom-table">
        <el-table :data="upAccountData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="merchant_id" label="商户ID" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchantName" label="商户名称" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="banlance" label="可用金额（元）" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="frozen_amt" label></el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
      </div>-->
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      input: "",
      total: null,
      pageSize: 10,
      upAccountData: [],
      companyValue: "",
      CompanyOptions: [
        {
          value: "司机宝",
          label: "司机宝"
        }
      ]
    };
  },
  mounted() {
    this.CompanyOptions = JSON.parse(localStorage.getItem("nameList")) || [];
    this.accountListPost();
  },
  methods: {
    // currentChange(size) {
    //   console.log(size)
    //   this.accountListPost(size)
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条aaaaa`);
      this.pageSize = val;
      this.accountListPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.accountListPost(val);
    },
    // 重置
    merchantsReset() {
      this.companyValue = "";
      this.accountListPost();
    },
    // 搜索
    merchantsSearch() {
      this.accountListPost();
    },
    accountListPost(size) {
      const loading = this.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.accountList, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        merchantId: this.companyValue
      }).then(
        d => {
          console.log(d.status);
            loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.upAccountData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClick(row) {
      console.log(row);
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.capitalAccount {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 105px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/financial/money/capitalAccount.vue